/* ZAKDOR - two small storefront jobs.

   1. Mark product images as loaded so the skeleton shimmer can stop.
   2. "Tell me when it is back" on a sold-out card: take a number, hand it
      to the app, done. The message itself goes out from the app the moment
      Shopify says the variant has stock again.

   The button spinner that used to live here is gone. Loading feedback is
   one thing now, in ax-load.js: the same pair of arcs everywhere. */
(function () {
  'use strict';

  /* iPhones only apply :active on a tap once something on the page listens
     for touches - without this the bottom bar's press would show nowhere. */
  document.addEventListener('touchstart', function () {}, { passive: true });

  /* ---------------- images ---------------- */

  function ok(img) {
    var box = img.closest ? img.closest('.card-gallery,.product-media-container') : null;
    if (box) box.setAttribute('data-ax-ok', '1');
  }

  function sweep() {
    var imgs = document.querySelectorAll('img.product-media__image:not([data-ax-seen])');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      img.setAttribute('data-ax-seen', '1');
      if (img.complete && img.naturalWidth > 0) {
        ok(img);
      } else {
        img.addEventListener('load', function () { ok(this); }, { once: true });
        img.addEventListener('error', function () { ok(this); }, { once: true });
      }
    }
  }

  /* ---------------- back in stock ---------------- */

  var CSS = '.axst{position:fixed;inset:0;z-index:2147483004;display:grid;place-items:center;padding:20px;'
    + 'background:rgba(5,11,24,.72)}'
    + '.axst form{background:#fff;color:#0A1730;border-radius:16px;padding:24px;max-width:340px;width:100%;'
    + 'font-family:inherit;box-shadow:0 24px 60px rgba(2,6,16,.45)}'
    + '.axst b{display:block;font-size:16px;margin-bottom:6px}'
    + '.axst p{margin:0 0 16px;font-size:13px;color:#7A8496;line-height:1.5}'
    + '.axst input{width:100%;box-sizing:border-box;padding:13px;font:inherit;font-size:15px;'
    + 'border:1px solid #D9DFEA;border-radius:10px;background:#fff;color:#0A1730}'
    + '.axst input:focus{outline:0;border-color:#2C5CC5}'
    + '.axst .r{display:flex;gap:10px;margin-top:14px}'
    + '.axst button{flex:1;border:0;border-radius:10px;padding:13px;font:inherit;font-size:12px;'
    + 'font-weight:700;letter-spacing:.09em;text-transform:uppercase;cursor:pointer}'
    + '.axst .go{background:#0A1730;color:#fff}'
    + '.axst .no{background:#EEF1F6;color:#5A6779}'
    + '.axst .msg{margin:12px 0 0;font-size:12.5px;color:#96222A}'
    + '.axst .msg.ok{color:#0F7A3D}';

  var styled = false;
  function styles() {
    if (styled) return;
    styled = true;
    var s = document.createElement('style');
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function ask(btn) {
    styles();
    var box = document.createElement('div');
    box.className = 'axst';
    box.innerHTML = '<form novalidate><b>Tell me when it is back</b>'
      + '<p>We will send you one WhatsApp message the moment it is in stock again.</p>'
      + '<input name="phone" inputmode="numeric" maxlength="10" placeholder="98765 43210" autocomplete="tel">'
      + '<p class="msg" hidden></p>'
      + '<div class="r"><button type="button" class="no">Not now</button>'
      + '<button type="submit" class="go">Notify me</button></div></form>';
    document.body.appendChild(box);

    var form = box.querySelector('form');
    var msg = box.querySelector('.msg');
    form.phone.focus();

    function shut() { if (box.parentNode) box.parentNode.removeChild(box); }
    box.querySelector('.no').addEventListener('click', shut);
    box.addEventListener('click', function (e) { if (e.target === box) shut(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var phone = String(form.phone.value || '').replace(/\D/g, '');
      if (phone.length !== 10) {
        msg.textContent = 'Enter your 10-digit mobile number';
        msg.className = 'msg';
        msg.hidden = false;
        return;
      }
      fetch('/apps/track/stock', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          phone: phone,
          variant: btn.getAttribute('data-ax-stock'),
          handle: btn.getAttribute('data-handle'),
          title: btn.getAttribute('data-title'),
          price: btn.getAttribute('data-price')
        })
      }).then(function (r) { return r.json(); }).then(function (r) {
        if (!r || !r.ok) {
          msg.textContent = (r && r.reason) || 'Could not save that. Please try again.';
          msg.className = 'msg';
          msg.hidden = false;
          return;
        }
        msg.textContent = 'Done. We will message you as soon as it is back.';
        msg.className = 'msg ok';
        msg.hidden = false;
        setTimeout(shut, 1800);
      }).catch(function () {
        msg.textContent = 'Network problem. Please try again.';
        msg.className = 'msg';
        msg.hidden = false;
      });
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var b = e.target.closest('[data-ax-stock]');
    if (b) { e.preventDefault(); ask(b); }
  });

  /* ---------------- boot ---------------- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep);
  } else {
    sweep();
  }
  window.addEventListener('load', sweep);
  document.addEventListener('shopify:section:load', sweep);
  setTimeout(sweep, 900);
  setTimeout(sweep, 2500);
})();
